// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file url.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file url.proto.
 */
export const file_url: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Cgl1cmwucHJvdG8icQoJQ29tbXVuaXR5EhQKDGRpc3BsYXlfbmFtZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRIVCg1tZW1iZXJzX2NvdW50GAMgASgNEg0KBWNvbG9yGAQgASgJEhMKC3RhZ19pbmRpY2VzGAUgAygNIn8KB0NoYW5uZWwSFAoMZGlzcGxheV9uYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEg0KBWVtb2ppGAMgASgJEg0KBWNvbG9yGAQgASgJEh0KCWNvbW11bml0eRgFIAEoCzIKLkNvbW11bml0eRIMCgR1dWlkGAYgASgJIkAKBFVzZXISFAoMZGlzcGxheV9uYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEg0KBWNvbG9yGAMgASgJIhoKB1VSTERhdGESDwoHY29udGVudBgBIAEoDGIGcHJvdG8z',
  )

/**
 * @generated from message Community
 */
export type Community = Message<'Community'> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string

  /**
   * @generated from field: string description = 2;
   */
  description: string

  /**
   * @generated from field: uint32 members_count = 3;
   */
  membersCount: number

  /**
   * @generated from field: string color = 4;
   */
  color: string

  /**
   * @generated from field: repeated uint32 tag_indices = 5;
   */
  tagIndices: number[]
}

/**
 * Describes the message Community.
 * Use `create(CommunitySchema)` to create a new message.
 */
export const CommunitySchema: GenMessage<Community> =
  /*@__PURE__*/
  messageDesc(file_url, 0)

/**
 * @generated from message Channel
 */
export type Channel = Message<'Channel'> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string

  /**
   * @generated from field: string description = 2;
   */
  description: string

  /**
   * @generated from field: string emoji = 3;
   */
  emoji: string

  /**
   * @generated from field: string color = 4;
   */
  color: string

  /**
   * @generated from field: Community community = 5;
   */
  community?: Community

  /**
   * @generated from field: string uuid = 6;
   */
  uuid: string
}

/**
 * Describes the message Channel.
 * Use `create(ChannelSchema)` to create a new message.
 */
export const ChannelSchema: GenMessage<Channel> =
  /*@__PURE__*/
  messageDesc(file_url, 1)

/**
 * @generated from message User
 */
export type User = Message<'User'> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string

  /**
   * @generated from field: string description = 2;
   */
  description: string

  /**
   * @generated from field: string color = 3;
   */
  color: string
}

/**
 * Describes the message User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> =
  /*@__PURE__*/
  messageDesc(file_url, 2)

/**
 * @generated from message URLData
 */
export type URLData = Message<'URLData'> & {
  /**
   * Community, Channel, or User
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array
}

/**
 * Describes the message URLData.
 * Use `create(URLDataSchema)` to create a new message.
 */
export const URLDataSchema: GenMessage<URLData> =
  /*@__PURE__*/
  messageDesc(file_url, 3)
